<template>
  <div class="layout-footer">
    <div class="w-full pt-4" style="background-color: #f5f6f7">
      <div class="w-full max-w-screen-xl m-auto">
        <!-- 其他 -->
        <div class="text-center">
          <span class="mr-4 text-xs leading-9" style="color: #646a73">
            Copyright © 2024 {{ setting.company_name }}
          </span>
          <span class="mr-4 text-xs leading-9" style="color: #646a73">
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              style="color: #646a73"
            >
              {{ setting.icp }}
            </a>
          </span>

          <span class="text-xs leading-9" style="color: #646a73">
            <a
              target="_blank"
              class="text-white"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33100202001322"
            >
              <img src="@/assets/images/gongan.png" class="inline mr-1" />
              <span style="color: #646a73">
                {{ setting.gov_record }}
              </span>
            </a>
            <span class="pl-4 text-xs" style="color: #646a73">
              技术支持:台州金电保数字科技有限公司
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/api/config';
export default {
  name: 'Footer',
  components: {},
  data() {
    return { setting: {} };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getConfig();
  },
  methods: {
    async getConfig() {
      this.setting = (await config()) || {};
    },
  },
};
</script>

<style lang="less" scoped>
.headershadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06);
}
</style>
